import { render, staticRenderFns } from "./DefaultPaySectionForm.vue?vue&type=template&id=50827220&"
import script from "./DefaultPaySectionForm.vue?vue&type=script&lang=js&"
export * from "./DefaultPaySectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports